<template>
  <p :class="classnames">{{ message }} {{ count }}s</p>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'count-down-redirect-message'

  export default {
    name: 'CountDownRedirectMessage',
    components: {},
    mixins: [ bem ],
    props: {
      countDownFrom: {
        type: Number
      },
      message: {
        default: 'Reloading in',
        type: String
      },
      redirectTo: {
        default: function () {
          return { name: 'Products' }
        },
        type: [ String, Object ]
      }
    },
    data: function () {
      const {
        countDownFrom
      } = this

      return {
        count: countDownFrom || 3
      }
    },
    watch: {
      count: function () {
        const doneCountingDown = this.count === 1

        if (doneCountingDown) {
          this.$router.go()
        }
      }
    },
    created: function () {
      this.namespace = namespace
    },
    mounted: function () {
      this.countDown()
    },
    methods: {
      countDown: function () {
        const self = this

        setInterval(function () {
          self.decrementCount()
        }, 1000)
      },
      decrementCount: function () {
        const greaterThanZero = this.count > 0

        if (greaterThanZero) {
          this.count = this.count - 1
        } else {
          this.count = 0
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/CountDownRedirectMessage.vue